(() => {
  'use strict';
  if (Number(window.Shopify?.theme?.id) !== 186999570810) return;

  const selector = [
    '.product__info-container > [id^="price-"] .price-item',
    '#_rsi-cod-form-embed ._rsi-modal-checkout-line-value',
    '#_rsi-cod-form-embed ._rsi-modal-checkout-line-price',
    '#_rsi-cod-form-embed .rsi-cod-form-submit-total-value'
  ].join(', ');
  let queued = false;

  function formatDisplayMoney(value) {
    if (typeof value !== 'string') return value;
    if (/^\s*free\s*$/i.test(value)) return 'Gratuite';
    return value.replace(/([.,])\d+(?=\s*(?:DH|MAD)?\s*$)/i, '');
  }

  function formatNode(node) {
    const current = node.textContent;
    const formatted = formatDisplayMoney(current);
    if (formatted !== current) node.textContent = formatted;
  }

  function scan() {
    queued = false;
    document.querySelectorAll(selector).forEach(formatNode);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(scan);
  }

  function start() {
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    document.addEventListener('shopify:section:load', schedule);
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
